
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths } from 'next';
import { ItemsListingPage } from 'modules/catalog/pages/ItemsListingPage';
import { MarketplaceAPI } from 'revibe-api';
export default ItemsListingPage;
export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
    const paths: {
        params: {
            sex: string;
            category: string;
        };
        locale: string;
    }[] = [];
    const { data } = await MarketplaceAPI.getCategories({
        token: process.env.REVIBE_API_TOKEN as string,
    });
    const categories: MarketplaceAPI.Category[] = Array.isArray(data) ? data : [];
    ['male', 'female'].forEach((sex) => {
        categories.forEach((category) => paths.push(...(locales as string[]).map((locale) => ({
            params: { sex, category: category.slug },
            locale,
        }))));
    });
    return {
        paths,
        fallback: 'blocking',
    };
};

    async function __Next_Translate__getStaticProps__18c6845d7af__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/shop/items/[sex]/[category]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c6845d7af__ as getStaticProps }
  